<template>
  <g>
    <g>
      <path
        :d="path.data"
        :style="path.style"
      />
    </g>
    <g>
      <text
        v-if="pathFilter"
        class="cf-node__link-filter"
        :transform="pathFilter.transform"
        :style="pathFilter.style"
        :font-family="isFilterNode ? 'FontAwesome' : ''"
        dominant-baseline="middle"
        text-anchor="middle"
        @click="$emit('editNodeLinks', line.originNode)"
      >
        {{ isFilterNode ? '&#xf0b0' : pathFilter.filterValue }}
      </text>
    </g>
  </g>
</template>
<script>
import { nodeLinkStyles } from '../../helpers/constants';

export default {
  name: 'NodeLink',
  props: {
    line: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    isFilterNode() {
      return this.line.originNode && this.line.originNode.nodeTypeId == 'RouterNode';
    },
    path() {
      let path = {};
      const dist = this.distance(this.line.x1, this.line.y1, this.line.x2, this.line.y2) * 0.25;
      path = {
        data: `M ${this.line.x1}, ${this.line.y1} C ${this.line.x1 + dist}, ${this.line.y1}, ${this.line.x2 - dist}, ${this.line.y2}, ${this.line.x2}, ${this.line.y2}`,
        style: this.line.style
      };
      return path;
    },
    pathFilter() {
      let pathFilter = {};
      const pos = this.computeConnectionPoint(this.line.x1, this.line.y1, this.line.x2, this.line.y2, 0.5);
      pathFilter = {
        transform: `translate(${pos.x}, ${pos.y - 25})`,
        filterValue: this.line.filter,
        style: {
          stroke: !this.isFilterNode ? nodeLinkStyles.filterStrokeColor : '',
          strokeWidth: nodeLinkStyles.filterStrokeWidth,
          fill: this.pathFillColor,
        }
      };
      return pathFilter;
    },
    pathFillColor() {
      if (this.line.isValid !== undefined && !this.line.isValid) {
        return nodeLinkStyles.filterErrorFillColor;
      }
      return this.line.criteria && this.line.criteria.length > 0 ? nodeLinkStyles.filterActiveFillColor : nodeLinkStyles.filterFillColor;
    }
  },
  methods: {
    distance(x1, y1, x2, y2) {
      return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    },
    computeConnectionPoint(x1, y1, x2, y2, t) {
      const dist = this.distance(x1, y1, x2, y2);
      const p0 = { x: x1, y: y1 };
      const p1 = { x: x1 + dist * 0.25, y: y1 };
      const p2 = { x: x2 - dist * 0.25, y: y2 };
      const p3 = { x: x2, y: y2 };
      const c1 = (1 - t) * (1 - t) * (1 - t);
      const c2 = 3 * ((1 - t) * (1 - t)) * t;
      const c3 = 3 * (1 - t) * (t * t);
      const c4 = t * t * t;
      const x = c1 * p0.x + c2 * p1.x + c3 * p2.x + c4 * p3.x;
      const y = c1 * p0.y + c2 * p1.y + c3 * p2.y + c4 * p3.y;
      return { x: x, y: y };
    }
  }
};
</script>